@if (operator?.showPasswordExpiryReminder) {
  <itfg-message-banner
    [title]="'auth.passwordExpiryReminderTitle' | translate:{days:operator?.passwordExpiresInDays}"
  [subtitle]="'auth.passwordExpiryReminderSubtitle' | translate"></itfg-message-banner>
}
<div layout="row"
  layout-wrap>
  <div flex="100"
    flex-gt-sm="50"
    flex-gt-md="50">
    <mat-card appearance="outlined">
      <mat-card-title>
        <div layout="row"
          layout-align="start center">
          <mat-icon>person</mat-icon>
          <span [translate]="'administrators.personalData'"></span>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div layout="column">
          <mat-form-field flex>
            <input matInput
              type="text"
              readonly
              value="{{ operator.id }}"
              placeholder="{{ 'global.number' | translate }}" />
              <mat-label>{{ 'global.number' | translate }}</mat-label>
            </mat-form-field>
            <mat-form-field flex>
              <input matInput
                type="text"
                readonly
                value="{{ operator.firstName }}"
                placeholder="{{ 'users.firstName' | translate }}" />
                <mat-label>{{ 'users.firstName' | translate }}</mat-label>
              </mat-form-field>
              <mat-form-field flex>
                <input matInput
                  type="text"
                  readonly
                  value="{{ operator.lastName }}"
                  placeholder="{{ 'users.lastName' | translate }}" />
                  <mat-label>{{ 'users.lastName' | translate }}</mat-label>
                </mat-form-field>
                <mat-form-field flex>
                  <input matInput
                    type="text"
                    readonly
                    value="{{ operator.email }}"
                    placeholder="{{ 'global.email' | translate }}" />
                    <mat-label>{{ 'global.email' | translate }}</mat-label>
                  </mat-form-field>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div flex="100"
            flex-gt-sm="50"
            flex-gt-md="50">
            <mat-card appearance="outlined">
              <mat-card-title>
                <div layout="row"
                  layout-align="start center">
                  <mat-icon>lock</mat-icon>
                  <span>{{ 'auth.passwordUpdateLabel' | translate }}</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <form novalidate
                  [formGroup]="updatePasswordForm"
                  (ngSubmit)="onSubmit(formDirective);"
                  layout="column"
                  #formDirective="ngForm">

                  <mat-form-field flex>
                    <input #oldPassword
                      required
                      formControlName="oldPassword"
                      matInput
                      type="password"
                      placeholder="{{ 'global.password' | translate }}" />
                      <mat-label>{{ 'auth.oldPasswordLabel' | translate }}</mat-label>
                      <button matSuffix
                        tabindex="-1"
                        mat-icon-button
                        [itfgTogglePasswordVisibility]="oldPassword"
                        class="input-suffix-button"
                        type="button">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <!-- <mat-hint>
                      <span>{{ 'auth.passwordValidTo' | translate:{'date': (operator?.passwordExpiresAt | date)} }}</span>
                    </mat-hint> -->
                    @if (updatePasswordForm.get('oldPassword').hasError('required')) {
                      <mat-error
                      [translate]="'forms.required'"></mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field flex>
                    <input #password
                      required
                      formControlName="password"
                      matInput
                      type="password"
                      placeholder="{{ 'global.password' | translate }}" />
                      <mat-label>{{ 'auth.newPasswordLabel' | translate }}</mat-label>
                      <button matSuffix
                        tabindex="-1"
                        mat-icon-button
                        [itfgTogglePasswordVisibility]="password"
                        class="input-suffix-button"
                        type="button">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      @if (updatePasswordForm.get('password').hasError('required')) {
                        <mat-error
                        [translate]="'forms.required'"></mat-error>
                      }
                    </mat-form-field>
                    <mat-form-field flex>
                      <input #passwordConfirm
                        matInput
                        required
                        formControlName="passwordConfirm"
                        type="password"
                        placeholder="{{ 'global.confirmPassword' | translate }}" />
                        <mat-label>{{ 'global.confirmPassword' | translate }}</mat-label>
                        <button matSuffix
                          tabindex="-1"
                          mat-icon-button
                          [itfgTogglePasswordVisibility]="passwordConfirm"
                          class="input-suffix-button"
                          type="button">
                          <mat-icon>visibility</mat-icon>
                        </button>
                        @if (updatePasswordForm?.hasError('passwordsNotEqual')) {
                          <mat-error>
                            {{ 'forms.passwordsNotEqual' | translate }}
                          </mat-error>
                        }
                        @if (updatePasswordForm.get('passwordConfirm').hasError('required')) {
                          <mat-error
                          [translate]="'forms.required'"></mat-error>
                        }
                      </mat-form-field>

                      <!-- <itfg-message *ngIf="updatePasswordForm?.hasError('passwordsNotEqual') && updatePasswordForm.get('passwordConfirm')?.touched"
                      opened="false"
                      label="{{ 'global.error' | translate }}"
                      sublabel="{{ 'forms.passwordsNotEqual' | translate }}"
                    type="error"></itfg-message> -->

                    <div>
                      <button mat-raised-button
                        type="submit">
                        {{ 'global.save' | translate }}
                      </button>
                    </div>

                    <itfg-message [opened]="updatePasswordErrored"
                      label="{{ 'global.error' | translate }}"
                      [sublabel]="updatePasswordErrorMessage"
                    type="error"></itfg-message>
                  </form>

                </mat-card-content>

              </mat-card>
            </div>
          </div>
          <div layout="row"
            layout-wrap>
            <div flex="100"
              flex-gt-sm="100"
              flex-gt-md="50">
              <mat-card class="card"
                appearance="outlined"
                flex>
                <mat-card-title>
                  <div layout="row"
                    layout-align="start center">
                    <mat-icon>shield</mat-icon>
                    <span [translate]="'twoFactorAuth.trustedDevices'"></span>
                  </div>
                </mat-card-title>
                <mat-card-content>
                  @if (operator?.trustedDevices && operator.trustedDevices.length > 0) {
                    <itfg-data-table [data]="operator?.trustedDevices"
                      [columns]="columns"
                      [isClickable]="false">
                      <ng-template itfgDataTableTemplate="createTime"
                        let-value="value">
                        {{ value | itfgDateFormat }}
                      </ng-template>
                      <ng-template itfgDataTableTemplate="lastUsed"
                        let-value="value">
                        <span [matTooltip]="value | itfgDateFormat"
                          matTooltipPosition="above">
                          {{ value | itfgDateFormat: fromNowDateFormat }}
                        </span>
                      </ng-template>
                      <ng-template itfgDataTableTemplate="expire"
                        let-value="value">
                        <span [matTooltip]="value | itfgDateFormat"
                          matTooltipPosition="above">
                          {{ value | itfgDateFormat: fromNowDateFormat }}
                        </span>
                      </ng-template>
                      <ng-template itfgDataTableTemplate="userAgent.agent"
                        let-value="value">
                        <div layout="row"
                          layout-align="start end"
                          [matTooltip]="value"
                          matTooltipPosition="after">
                          <img class="browser-icon"
                            matListItemIcon
                            src="../assets/images/browser-icons/{{value | parseUserAgent:'icon'}}.png"
                            alt="Browser Logo">
                            <span>{{value | parseUserAgent}}</span>
                          </div>
                        </ng-template>
                        <ng-template itfgDataTableTemplate="actions"
                          let-row="row">
                          <button color="warn"
                            mat-stroked-button
                            matTooltipPosition="after"
                            matTooltip="{{'twoFactorAuth.revokeTrustedDeviceHint' | translate}}"
                            (click)="revokeTrustedDeviceById(row.id)">
                            <span>Отмени</span>
                          </button>
                        </ng-template>
                      </itfg-data-table>
                    } @else {
                      <p>{{ 'twoFactorAuth.noTrustedDevices' | translate }}</p>
                    }
                  </mat-card-content>
                  <mat-card-footer class="card-footer">
                    @if(operator?.trustedDevices && operator.trustedDevices.length > 0) {
                      <button type="button"
                        mat-stroked-button
                        matTooltip="{{'twoFactorAuth.revokeTrustedDevicesHint' | translate}}"
                        color="warn"
                      (click)="revokeTrustedDevicesAccess()">{{ 'twoFactorAuth.revokeAllDevices' | translate }}</button>
                    }
                  </mat-card-footer>
                </mat-card>
              </div>

            </div>
